module.exports = "/_next/static/media/0eef3549fa226ba91a83c2e10c137e4e.svg";